

import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-bs4"; // or "datatables.net" for custom styling
import { Link } from "react-router-dom";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";

function CustomerUi({data}) {
  const tableRef = useRef(null); // Creating a ref for the table

  useEffect(() => {
    // Initialize DataTable when the component mounts
    const dataTable = $(tableRef.current).DataTable({
      paging: true,
      lengthChange: false,
      searching: false,
      ordering: true,
      info: true,
      autoWidth: true,
      responsive: true,
      pageLength:10
    });

    // Cleanup function to destroy DataTable when the component unmounts
    return () => {
      dataTable.destroy();
    };
  }, []);


  return (
    <div>
      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Customer</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right mt-1">
                    <Link to="/create">
                  <button className="btn btn-primary">Add Customer</button>
                  </Link>
                </ol>
              </div>
            </div>
          </div>
        </section>

        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row justify-content-between">
                      <div className="d-md-flex justify-content-between align-items-center dt-layout-start col-md-auto mr-auto" >
                      <div className="dt-search ">
                          <label htmlFor="dt-search-0">Search:</label>
                          <input
                            type="search"
                            className="form-control form-control-sm"
                            id="dt-search-0"
                            placeholder="Search Here"
                            aria-controls="DataTables_Table_0"
                          />
                        </div>
                        </div>
                      <div className="d-md-flex justify-content-between align-items-center dt-layout-end col-md-auto ml-auto">
                       
                      </div>
                    </div>

                    <table
                      ref={tableRef} // Use ref here
                      className="table table-bordered table-striped"
                    >
                      <thead>
                        <tr>
                          <th>Rendering engine</th>
                          <th>Browser</th>
                          <th>Platform(s)</th>
                          <th>Engine version</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((row, index) => (
                          <tr key={index}>
                            <td>{row.engine}</td>
                            <td>{row.browser}</td>
                            <td>{row.platform}</td>
                            <td>{row.version}</td>
                            <td style={{width:"10%"}}>
                              <div className="d-flex">
                                <button className="border-0 bg-transparent">
                                  <i class="fas fa-eye text-primary"></i>
                                </button>
                                <button className="border-0 bg-transparent" type="button"  data-toggle="modal" data-target="#modal-default">
                                  <i className="fas fa-edit text-success"> </i>
                                </button>
                                <button className="border-0 bg-transparent" type="button" data-toggle="modal" data-target="#modal-danger">
                                  <i className="fas fa-trash text-danger"> </i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <ConfirmModal confirmFn={""} text={"Are you sure,want to Delete?"} buttonText={"Delete"}/>
    </div>
  );
}

export default CustomerUi;
